import React, { Fragment, useCallback, useEffect, useState } from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  NoDataFound,
} from "../../../../components/table/tableComponent";
import DefaultButton from "../../../../components/buttons/defaultButton";
import TableSkeleton from "../../../../components/skeleton/tableSkeleton";
import { BsEye } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { getStorageHistoryList } from "../../../../../services/workspace/history.service";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { MdOutlineWorkHistory } from "react-icons/md";
import DefaultBadge from "../../../../components/badge/defaultBadge";

const StorageHistoryTable = () => {
  const [loading, setLoading] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [fetchMore, setfetchMore] = useState(false);
  const [tableData, setTableData] = useState();
  const [totalData, setTotalData] = useState();
  const { limit } = useSelector((state) => state.global);

  const headers = [
    "Storage Plan",
    "Storage Capacity",
    "Amount",
    "Purchase At",
    "Status",
    "Action",
  ];

  const navigate = useNavigate();
  //   const _actions = (item) => [
  //     {
  //       access: null,
  //       component: (
  //         <ActionButton
  //           access={null}
  //           component={
  //             <DefaultButton
  //               variant="default"
  //               icon={<BsEye />}
  //               tooltip={"View"}
  //               onClick={() => {
  //                 navigate(
  //                   `/configuration/manage-history/payment-view/${item?.uuid}`
  //                 );
  //               }}
  //             />
  //           }
  //           module={null}
  //           submodule={null}
  //         />
  //       ),
  //     },
  //   ];

  const fetchData = useCallback(() => {
    if (currentPage == 0 || !fetchMore) {
      setLoading(true);
    }
    getStorageHistoryList({ search: "", page: currentPage, limit })
      .then((response) => {
        setTableData((prevTableData) => {
          const combinedData =
            currentPage === 1
              ? [...response.data]
              : [...prevTableData, ...response.data];
          return combinedData;
        });
        setTotalData(response.total);
      })
      .catch((error) => {
        toast.error("Failed to fetch reminder data!");
        console.error("Error fetching data: ", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage, limit]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleViewClick = (item) => {
    navigate(`/configuration/manage-history/package-view/${item?.uuid}`, {
      state: { item },
    });
  };

  return (
    <div className="flex flex-col gap-2">
      <Fragment>
        <Table className="shadow-md">
          <TableHeader>
            <TableRow>
              {headers.map((header, index) => (
                <TableHead sticky key={index}>
                  {header}
                </TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading ? (
              <TableSkeleton colSpan={headers.length} />
            ) : (
              <>
                {tableData?.length > 0 ? (
                  tableData?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item?.storage_package?.name}</TableCell>
                      <TableCell>
                        {item?.storage_package?.storage_capacity} GB
                      </TableCell>
                      <TableCell>{item?.final_storage_price_annual}</TableCell>
                      <TableCell>{item?.created_at}</TableCell>
                      <TableCell><DefaultBadge custom={item?.status === 0 ? "Active" : "Expired"} /></TableCell>

                      <TableCell sticky className={"flex items-center gap-2"}>
                        <DefaultButton
                          variant="iconButton"
                          icon={<BsEye />}
                          tooltip={"View"}
                          onClick={() => handleViewClick(item)}
                        />
                        <DefaultButton
                          variant="iconButton"
                          icon={<MdOutlineWorkHistory />}
                          tooltip={"View Transaction"}
                          onClick={() => {
                            navigate(
                              `/configuration/manage-history/payment-view/${item?.payment_history?.uuid}`
                            );
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <NoDataFound colSpan={headers.length} />
                  </TableRow>
                )}
              </>
            )}
          </TableBody>
        </Table>
      </Fragment>
    </div>
  );
};

export default StorageHistoryTable;
